module.exports = __webpack_public_path__ + "static/media/rectangle-10.7cab6eaf.svg";